import './app.scss';

/*
 * Bootstrap Components
 * =========================================================================== */
import BootstrapTab from 'bootstrap/js/dist/tab.js';
// import BootstrapTooltip from "bootstrap/js/dist/tooltip.js";
// import BootstrapPopover from "bootstrap/js/dist/popover.js";

/*
 * Other 3rd Party Dependencies
 * =========================================================================== */

/*
 * Custom Dependencies
 * =========================================================================== */
// Components
import AlertBanner from './components/AlertBanner/AlertBanner';
import Accordion from './components/Accordion';
import AppHeader from './components/AppHeader';
import AppSideNav from './components/AppSideNav';
import DynamicCTA from './components/DynamicCTA';
import LocationMap from './components/LocationMap';
import HeroBanner from './components/HeroBanner';
import ImageGalleries from './components/ImageGallery';
import JumpLinks from './components/JumpLinks';
import NewsletterSubscription from './components/NewsletterSubscription';
import ProviderSearch from './components/ProviderSearch';
import ProvidersGrid from './components/ProvidersGrid';
import RelatedArticles from './components/RelatedArticles';
import SimpleAccordion from './components/SimpleAccordion';
import SkipToContent from './components/SkipToContent';
import Testimonial from './components/Testimonial';
import YouTube from './components/YouTube';

/*
 * Setup the global App object
 * =========================================================================== */
type App = {
  init: () => void;
  // dev: {
  //   [key: string]: any;
  // };
};
let App = <App>{};

// Gather up any component initializations here so we can easily initialize everything with a single call
// Note: each of these init methods should implement early return if they cannot be initialized.
App.init = () => {
  AlertBanner.init();
  Accordion.init();
  AppHeader.init();
  AppSideNav.init();
  DynamicCTA.init();
  LocationMap.init();
  HeroBanner.init();
  ImageGalleries.init();
  JumpLinks.init();
  NewsletterSubscription.init();
  ProviderSearch.init();
  ProvidersGrid.init();
  RelatedArticles.init();
  SimpleAccordion.init();
  SkipToContent.init();
  Testimonial.init();
  YouTube.init();
};

/*
 * Using 'pageshow' here to make sure the mega menu nav is closed on page load.
 * This should also handle pages loaded from the browser's bfcache
 * =========================================================================== */
window.addEventListener('pageshow', () => {
  AppHeader.closeAll();
});

/*
 * Using 'DOMContentLoaded' here so App.init() runs as soon as the DOM is ready,
 * without waiting for all assets to load (images, stylesheets, etc.).
 * =========================================================================== */
window.addEventListener('DOMContentLoaded', () => {
  App.init();

  // Close nav on press of ESC key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      AppHeader.closeAll();
    }
    if (event.key === 'Tab') {
      document.body.classList.add('using-keyboard');
    }
  });

  document.addEventListener('mousedown', () => {
    document.body.classList.remove('using-keyboard');
  });

  // Initialize Bootstrap Popovers
  // const popoverTriggerList = document.querySelectorAll(
  //   '[data-bs-toggle="popover"]'
  // );
  // if (popoverTriggerList) {
  //   popoverTriggerList.forEach((popoverTriggerEl) => {
  //     new BootstrapPopover(popoverTriggerEl, {
  //       html: true,
  //     });
  //   });
  // }

  // Initialize Bootstrap Tabs
  const triggerTabList = document.querySelectorAll('.nav-tabs[role="tablist"] button[data-bs-toggle="tab"]');
  triggerTabList.forEach((triggerEl) => {
    const tabTrigger = new BootstrapTab(triggerEl);

    triggerEl.addEventListener('click', (event) => {
      event.preventDefault();
      tabTrigger.show();
    });
  });

  // Initialize Bootstrap Tooltips
  // const tooltipTriggerList = document.querySelectorAll(
  //   '[data-bs-toggle="tooltip"]'
  // );
  // if (tooltipTriggerList) {
  //   tooltipTriggerList.forEach((tooltipTriggerEl) => {
  //     new BootstrapTooltip(tooltipTriggerEl);
  //   });
  // }
});
